/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanUnit } from './PlanUnit';
import {
    PlanUnitFromJSON,
    PlanUnitFromJSONTyped,
    PlanUnitToJSON,
    PlanUnitToJSONTyped,
} from './PlanUnit';

/**
 * 
 * @export
 * @interface AssignableTrainingPlan
 */
export interface AssignableTrainingPlan {
    /**
     * 
     * @type {string}
     * @memberof AssignableTrainingPlan
     */
    creatorId: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableTrainingPlan
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignableTrainingPlan
     */
    viewerIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssignableTrainingPlan
     */
    title: string;
    /**
     * 
     * @type {Array<PlanUnit>}
     * @memberof AssignableTrainingPlan
     */
    units: Array<PlanUnit>;
    /**
     * 
     * @type {boolean}
     * @memberof AssignableTrainingPlan
     */
    unlockMode: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignableTrainingPlan
     */
    allowUsersToRateWorkout: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssignableTrainingPlan
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableTrainingPlan
     */
    trainingDateIso?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignableTrainingPlan
     */
    editorIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignableTrainingPlan
     */
    missingDeckIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AssignableTrainingPlan
     */
    userHasDecks: boolean;
}

/**
 * Check if a given object implements the AssignableTrainingPlan interface.
 */
export function instanceOfAssignableTrainingPlan(value: object): value is AssignableTrainingPlan {
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('viewerIds' in value) || value['viewerIds'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('units' in value) || value['units'] === undefined) return false;
    if (!('unlockMode' in value) || value['unlockMode'] === undefined) return false;
    if (!('allowUsersToRateWorkout' in value) || value['allowUsersToRateWorkout'] === undefined) return false;
    if (!('editorIds' in value) || value['editorIds'] === undefined) return false;
    if (!('missingDeckIds' in value) || value['missingDeckIds'] === undefined) return false;
    if (!('userHasDecks' in value) || value['userHasDecks'] === undefined) return false;
    return true;
}

export function AssignableTrainingPlanFromJSON(json: any): AssignableTrainingPlan {
    return AssignableTrainingPlanFromJSONTyped(json, false);
}

export function AssignableTrainingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignableTrainingPlan {
    if (json == null) {
        return json;
    }
    return {
        
        'creatorId': json['creatorId'],
        'id': json['id'],
        'viewerIds': json['viewerIds'],
        'title': json['title'],
        'units': ((json['units'] as Array<any>).map(PlanUnitFromJSON)),
        'unlockMode': json['unlockMode'],
        'allowUsersToRateWorkout': json['allowUsersToRateWorkout'],
        'description': json['description'] == null ? undefined : json['description'],
        'trainingDateIso': json['trainingDateIso'] == null ? undefined : json['trainingDateIso'],
        'editorIds': json['editorIds'],
        'missingDeckIds': json['missingDeckIds'],
        'userHasDecks': json['userHasDecks'],
    };
}

export function AssignableTrainingPlanToJSON(json: any): AssignableTrainingPlan {
    return AssignableTrainingPlanToJSONTyped(json, false);
}

export function AssignableTrainingPlanToJSONTyped(value?: AssignableTrainingPlan | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creatorId': value['creatorId'],
        'id': value['id'],
        'viewerIds': value['viewerIds'],
        'title': value['title'],
        'units': ((value['units'] as Array<any>).map(PlanUnitToJSON)),
        'unlockMode': value['unlockMode'],
        'allowUsersToRateWorkout': value['allowUsersToRateWorkout'],
        'description': value['description'],
        'trainingDateIso': value['trainingDateIso'],
        'editorIds': value['editorIds'],
        'missingDeckIds': value['missingDeckIds'],
        'userHasDecks': value['userHasDecks'],
    };
}

